module.exports = __webpack_public_path__ + "img/intro-screen-help-female.fbb87bfc.webp";